import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { baseUrl, customHeaders, umsUrl, adminAPIURL } from '../../../../../Containers/Config/index.js';
import { PROFILE_TAB_DASHBOARD, PROFILE_TAB_DASHBOARD_SUCCESS, PROFILE_TAB_DASHBOARD_ERROR } from '../../actions.js';
import apiCall from '../../../apiCall.js';

function* getProfileTabDashboard({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v2/admin/customer/dashboard-card-summary`,
      method: 'GET',
      headers: {
        // Authorization: Constant?.CLIENT_TOKEN,
        ...filteredHeaders,
        // withCredentials: true
      },
      params: payload?.urlParams,
    });

    if (response.status === 200) {
      yield put({
        type: PROFILE_TAB_DASHBOARD_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: PROFILE_TAB_DASHBOARD_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: PROFILE_TAB_DASHBOARD_ERROR, payload: error });
  }
}

export function* watchProfileTabDashboard() {
  yield takeEvery(PROFILE_TAB_DASHBOARD, getProfileTabDashboard);
}

function* watchProfileTabDashboardSaga() {
  yield all([fork(watchProfileTabDashboard)]);
}

export default watchProfileTabDashboardSaga;
